import React from "react";

const CheckoutField = ({ label, type = "text", required, value, onChange, testid }) => (
  <label className="block">
    <span className="mb-2 block font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-zinc-400">{label}{required && " *"}</span>
    <input
      type={type}
      required={required}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full rounded-[10px] border border-white/15 bg-white/5 px-4 py-3 text-sm text-white placeholder-zinc-600 transition-all duration-200 focus:border-white/40 focus:bg-white/10 focus:outline-none focus:ring-1 focus:ring-cynos-red/50"
      placeholder={`Enter ${label.toLowerCase()}`}
      data-testid={`field-${testid}`}
    />
  </label>
);

export default CheckoutField;
